import TagBox from "devextreme-react/tag-box";
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { financeHelperApi } from '../../../api/finance/financeHelperApi';
import { useCommonContext } from "../../../contexts/common";

const TagBoxHinhThucNopBom = (
    { 
        value,
        onValueChanged,
        width,
        showClearButton,
        is_readonly }) => {
    const [hinhThucNopBoms, setHinhThucNopBoms] = useState([]);
    const { dm_coso_id } = useSelector(x => x.coSo);
    useEffect(() => {
        handleReloadHinhThucNopBoms();
    }, [])
    const handleReloadHinhThucNopBoms = async () => {
        const res = await financeHelperApi.sf_hinhthucnopbom_select_all();
        if (res.is_success) {
            if (dm_coso_id == 1) {
                setHinhThucNopBoms(res.data.data.filter(x => x.id > 0 && x.dm_coso_id == 1));
            } else {
                setHinhThucNopBoms(res.data.data.filter(x=> x.id > 0 && x.dm_coso_id != 1))
            }

        }
    }
    const { translate } = useCommonContext();
    return (
        <TagBox dataSource={hinhThucNopBoms}
            displayExpr={"name"}
            valueExpr={"id"}
            value={value}
            stylingMode={"outlined"}
            readOnly={is_readonly}
            placeholder={translate("Chọn kỳ nộp")}
            width={width ?? "100%"}
            showClearButton={showClearButton}
            onValueChanged={(e) => {
                if (e.event) {
                    if (e.value) {
                        const data = hinhThucNopBoms.filter(x => e.value.includes(x.id))
                        onValueChanged(e.value, data)
                    } else {
                        onValueChanged([], [])
                    }
                }
            }} />
    );
}
export default TagBoxHinhThucNopBom

